import React from 'react';
import { Link } from 'react-router-dom';
import { Network, ArrowRight } from 'lucide-react';
import AnimatedSection from '../AnimatedSection';

const CtaSection = () => {
  return (
    <div className="py-24 bg-gradient-to-br from-avn-purple-900 to-avn-purple-800 text-white">
      <div className="container mx-auto px-4 text-center">
        <AnimatedSection>
          <h2 className="text-4xl md:text-5xl font-bold mb-8">
            Ready to Transform Your Agricultural Future? Join for Free!
          </h2>
          <p className="text-xl text-white/90 mb-12 max-w-2xl mx-auto">
            Join thousands of farmers who are already benefiting from our innovative platform. Currently free during our beta phase.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Link
              to="/signup"
              className="bg-white text-avn-purple-700 px-8 py-4 rounded-lg hover:bg-avn-purple-50 transition-colors inline-flex items-center justify-center gap-3 text-lg"
            >
              <Network className="h-6 w-6" />
              <span>Join AVN Network</span>
            </Link>
            <Link
              to="/dashboard"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg hover:bg-white/10 transition-colors inline-flex items-center justify-center gap-3 text-lg"
            >
              <ArrowRight className="h-6 w-6" />
              <span>View Demo</span>
            </Link>
          </div>
        </AnimatedSection>
      </div>
    </div>
  );
};

export default CtaSection;